import React, { useState, useEffect } from "react";
import { Table, message } from "antd";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getExistedSchemesAplication } from "../../../../auth/services/privateapicalling";
import DistrictAllForms from "../CommonForm";
// import FormsQuery from "./component/indexForm";
import {
  AgriProductsAPMC,
  AmendmentStaffMarketCommittee,
  AppointmentSecretaryAPMC,
  BuyingLandAPMC,
  ContractualAppointmentSecretaryAPMC,
  PayComission,
  PermAppointmentSecretaryAPMC,
  PromotionSecretaryMarketCommittee,
  ProposalDonation,
  ProposalLoan,
  SellingLandAPMC,
  StudyTour,
  YardAPMC,
} from "../../../LandDistrict/Json/AllData";

const FormsAuthorityTable = () => {
  const token = useSelector((state: any) => state.auth.token);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const location = useLocation();
  const type = location.state?.type;

  // API integration states
  const [existData, setExistData] = useState<any | null>(null);
  const [queries, setQueries] = useState<any[]>([]);
  const [unverifiedFields, setUnverifiedFields] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emptyFields, setEmptyFields] = useState(new Set());
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [applicationId, setApplicationID] = useState(location?.state?.applicationId);
  const [id, setId] = useState(location?.state?.id);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;

  // Extract unverified fields
  const extractUnverifiedFields = (apiData: any) => {
    const unverified: string[] = [];
    if (apiData?.annexureOne) {
      Object.keys(apiData.annexureOne).forEach(fieldName => {
        const fieldData = apiData.annexureOne[fieldName];
        if (fieldData?.transaction && Array.isArray(fieldData.transaction)) {
          const lastTransaction = fieldData.transaction[fieldData.transaction.length - 1];
          if (lastTransaction?.isVerified === false) {
            unverified.push(fieldName);
          }
        }
      });
    }
    return unverified;
  };

  // Generate queries
  const generateQueries = (apiData: any) => {
    const generatedQueries: any[] = [];
    let keyCounter = 1;
    if (apiData?.annexureOne) {
      Object.keys(apiData.annexureOne).forEach(fieldName => {
        const fieldData = apiData.annexureOne[fieldName];
        if (fieldData?.transaction && Array.isArray(fieldData.transaction)) {
          const lastTransaction = fieldData.transaction[fieldData.transaction.length - 1];
          if (lastTransaction?.isVerified === false) {
            generatedQueries.push({
              key: keyCounter++,
              annexure: "Annexure 1",
              annexureType: "annexureOne",
              fieldNumber: fieldName,
              comment: lastTransaction.comment || "No comment provided",
              status: "reject",
              checked: false,
              fieldName: fieldName,
              transactionData: lastTransaction,
              standardizedComment: ""
            });
          }
        }
      });
    }
    return generatedQueries;
  };

  // Fetch application data
  const getExistedApplication = async () => {
    try {
      const response = await getExistedSchemesAplication(token, applicationId, id);
      if (response?.success) {
        setExistData(response?.data);
      
        const generatedQueries = generateQueries(response.data);
        const unverified = extractUnverifiedFields(response.data);
   
        setQueries(generatedQueries);
        setUnverifiedFields(unverified);
      } else {
        message.error("Failed to fetch application data");
      }
    } catch (error) {
      message.error("Error occurred while fetching application data");
    }
  };

  useEffect(() => {
    if (token && applicationId && id) {
      getExistedApplication();
    }
  }, [token, applicationId, id]);



  // Handle submit
  


  // Helper to get the correct dataField array based on type
    let heading = "";
    const getDataField = () => {
      const typeNum = Number(existData?.scheme?.id);
   
      switch (typeNum) {
        case 39:
          heading = "Buying Land";
          return BuyingLandAPMC;
        case 40:
          heading = "Selling Land";
          return SellingLandAPMC;
        case 41:
          heading = "To control Agriculture products under the APMC - Application under Form-8";
          return AgriProductsAPMC;
        case 42:
          heading = "Declaration of the main yard/sub-yard of APMC";
          return YardAPMC;
        case 43:
          heading = " the new/permanent or temporary appointment of the Secretary in the Market Committee";
          return AppointmentSecretaryAPMC;
        case 44:
          heading = "Permanent appointment of Secretary in the Market Committee";
          return PermAppointmentSecretaryAPMC;
        case 45:
          heading = "Regarding amendment in the staff schedule of the Market Committee";
          return AmendmentStaffMarketCommittee;
        case 46:
          heading = "Regarding promotion from Assistant Secretary / Inspector to Secretary in the Market Committee";
          return PromotionSecretaryMarketCommittee;
        case 47:
          heading = "Regarding contractual appointment of Secretary / employee after retirement";
          return ContractualAppointmentSecretaryAPMC;
        case 48:
          heading = "Regarding approval of 7th Pay Commission for Secretary / employee";
          return PayComission;
        case 49:
          heading = " Proposals regarding donation";
          return ProposalDonation;
        case 50:
          heading = "Proposals regarding loan";
          return ProposalLoan;
        case 51:
          heading = "Approval for Study Tours";
          return StudyTour;
        default:
          return BuyingLandAPMC;
      }
    };
    const dataField = getDataField();
  
    // Helper to get fieldNo from fieldName
    const getFieldNo = (fieldName) => {
  
      const found = dataField?.find(item => item.fieldName === fieldName);

      return found ? found.fieldNo : fieldName;
    };
    const getField = (fieldName) => {
    
    const found = dataField?.find(item => item.fieldName === fieldName);
  
    return found ? found.fieldVal : fieldName;
  };
   

  const columns = [
      {
      title: "Field Number",
      dataIndex: "fieldNumber",
      width: 150,
      render: (text) => (
       <span>{getFieldNo(text)}</span>
      ),
    },
    {
      title: "Field",
      dataIndex: "fieldNumber",
      width: 500,
      render: (text:string) => (
        <span style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{getField(text)}</span>
      ),
    },
    {
      title: "Comment",
      dataIndex: "comment",
      render: (text) => (
        <div style={{ maxWidth: '400px', wordWrap: 'break-word' }}>
          {text}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <span
          style={{
            color: status === "Resolved" ? "#0d6efd" : "red",
            fontWeight: 500
          }}
        >
          {"Pending"}
        </span>
      )
    },
  ];

  const pendingCount = queries.filter((q) => q.status === "Pending").length;
  const resolvedCount = queries.filter((q) => q.status === "Resolved").length;
  const totalCount = queries.length;

  return (
    <div className="page-wrapper">
        <div>
            <h2 className="m-3">Application Id - {applicationId}</h2>
        </div>
       {( existData?.status==="resubmission"||existData?.status==="reject")&& (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission")&&<div className="m-3 mx-5 card p-3">
           <div className="d-flex justify-content-between">
                <div className="mb-2">
                    <h3 className="mb-1">
                    <i className="feather feather-message-square text-info"></i> Senior Authority Queries & Comments
                    </h3>
                    <p className="text-muted">Resolved the given queries</p>
                </div>

                <div className="mb-3">
                    <span className="text-danger">●</span> Pending: {pendingCount}
                    <span className="text-warning ms-3">●</span> Resolved Queries: {resolvedCount}
                    <span className="text-success ms-3">●</span> Total Queries: {totalCount}
                </div>
           </div>

        <Table
            columns={columns}
            dataSource={queries}
            bordered
            pagination={false}
        />
        </div>}

        <DistrictAllForms
            unverifiedFields={unverifiedFields}
            userRole={userDetail?.Role?.Role_Identifier}
            existData={existData}
        />

        {/* This is the form table of District  */}
        {/* <FormsQuery /> */}
     {/* { existData?.status==="resubmission"&&userDetail?.Role?.Role_Identifier!=="SEC"&&  <div className="d-flex justify-content-end mb-3 me-5">
          <button className="btn btn-info " onClick={handleSubmitComments} disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit Again"}
          </button>
        </div>} */}
    </div>
  );
};

export default FormsAuthorityTable;
